<template>
  <li>
    <a :href="'#menu' + data.id" v-b-toggle class="dropdown-toggle" @click.prevent>
      {{ $t(data.name) }}
      <svg-to-left></svg-to-left>
    </a>
    <b-collapse :id="'menu' + data.id">
      <ul class="collapse list-unstyled sub-submenu show">
        <child-link v-for="child in data.children" :key="child.id" :data="child" :path="path + '/' + child.path" :toggleMobileMenu="toggleMobileMenu"></child-link>
      </ul>
    </b-collapse>
  </li>
</template>

<script>
import svgToLeft from '../../myComponent/svgToLeft.vue';
import childLink from './childLink.vue';
export default {
  name: 'childLi',
  components: {
    svgToLeft,
    childLink,
  },
  props: {
    data: Object,
    path: String,
    toggleMobileMenu: Function,
  },
};
</script>